import React from 'react';
import { Option } from 'shared-types/Common';
import { DiscountPrice } from '@common/components/Price';
import { Label } from '@common/components/Typography';
import Error from '@common/components/Error';
import { ToggleButton } from '@common/components';
import { List, ListItem } from './AmountPicker.styles';

export type AmountPickerProps = {
  options: Array<Option> | null;
  label: string;
  disabled: boolean;
};

type AmountPickerControlledProps = AmountPickerProps & {
  value: Option | null;
  onChange: (option: Option) => void;
  error?: string;
};

export const AmountPicker: React.FC<AmountPickerControlledProps> = ({
  disabled,
  error,
  label,
  onChange,
  options,
  value,
}) => (
  <>
    <Label>{label}</Label>
    <List>
      {options &&
        options.map((option) => (
          <ListItem key={option.id}>
            <ToggleButton
              type="button"
              isSelected={option.id === value?.id}
              onClick={() => onChange(option)}
              isDisabled={disabled || option.quantity === 0}
            >
              <DiscountPrice price={option.price} discount={option.discount} />
            </ToggleButton>
          </ListItem>
        ))}
    </List>
    {error && <Error error={error} />}
  </>
);
